/** Contact page and demo-request form in Arabic. Mirrors `../en/contact.js`. */
import contactPicture from '@/assets/images/contact/contact-ar.webp'
import { PRIVACY_EMAIL, SITE_EMAIL } from '@/data/links'

export const CONTACT = {
  eyebrow: 'تواصل معنا',
  title: 'لنُعدّ MeetNPlan لمكتبك',
  text: 'أخبرنا قليلًا عن فريقك وسنعاود التواصل معك خلال يوم عمل واحد لحجز عرض تجريبي.',
  image: contactPicture,
  imageAlt: 'طلب عرض تجريبي يصل إلى MeetNPlan، والرد في طريقه',
  emails: {
    title: 'أو راسلنا بالبريد الإلكتروني',
    items: [
      { label: 'الاستفسارات والعروض التجريبية', email: SITE_EMAIL },
      { label: 'الخصوصية وبياناتك', email: PRIVACY_EMAIL },
    ],
  },
}

export const FORM = {
  title: 'احجز عرضًا تجريبيًا',
  subtitle: 'نرد خلال يوم عمل واحد.',
  fields: {
    name: { label: 'الاسم', placeholder: 'الاسم الكامل' },
    email: { label: 'البريد الإلكتروني للعمل', placeholder: 'name@company.com' },
    company: { label: 'الشركة', placeholder: 'اسم الشركة' },
    phone: { label: 'الجوال', placeholder: '+966' },
    message: {
      label: 'الرسالة',
      hint: '· اختياري',
      placeholder: 'أخبرنا عن قاعاتك أو فروعك أو أي شيء آخر',
    },
  },
  size: {
    label: 'حجم الفريق',
    options: ['1–10', '11–50', '51–200', '200+'],
    default: '11–50',
  },
  notice: {
    before: 'نستخدم هذه البيانات للرد على طلبك فقط. راجع ',
    link: { label: 'سياسة الخصوصية', href: '/privacy' },
    after: '.',
  },
  submit: 'إرسال الطلب',
  errors: {
    missing: 'يرجى إدخال الاسم والبريد الإلكتروني للعمل والشركة والجوال.',
    failed: 'حدث خطأ ما. يرجى المحاولة مرة أخرى أو مراسلتنا مباشرة.',
  },
  sent: {
    title: (firstName) => (firstName ? `شكرًا، ${firstName}` : 'شكرًا لك'),
    posted: (email) => `استلمنا طلبك وسنراسلك على ${email} خلال يوم عمل واحد.`,
    mailed: 'فُتح تطبيق البريد لديك وفيه طلبك. اضغط إرسال وسنرد خلال يوم عمل واحد.',
    again: 'إرسال طلب آخر',
  },
  mailSubject: (company) => `طلب عرض تجريبي: ${company}`,
}
